import styled from "styled-components";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/section/footer/Footer";
import SocialsSection from "../../components/section/socials/SocialsSection";
import MenuSpacer from "../../components/spacer/MenuSpacer";
import ContactForm from "./components/ContactForm";
import ContactSection from "./components/ContactSection";
import SupportSection from "./components/SupportSection";

const Wrapper = styled.div`
  width: 100%;
`;

function ContactPage() {
  return (
    <Wrapper>
      <Navbar />
      <MenuSpacer extraSpace={true} />
      <ContactSection />
      <SupportSection />
      <ContactForm />
      <SocialsSection />
      <Footer />
    </Wrapper>
  );
}

export default ContactPage;
